<script>
  import { Grid, Row, Column, Checkbox } from "carbon-components-svelte";
  import ButtonNew from "lib/components/ButtonNew.svelte";
  import ButtonFileUploader from "lib/components/ButtonFileUploader.svelte";

  import {
    DataTable,
    Button,
    FileUploaderButton,
    TextInput,
  } from "carbon-components-svelte";
  import Undo16 from "carbon-icons-svelte/lib/Undo16";
  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
  import Save16 from "carbon-icons-svelte/lib/Save16";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  export let partitionlabel;
  export let analysisid;
  let canvas;
  let ctx;
  let currentid = 0;

  let allrects = [];

  let drawUIElements = true;
  let drawClicks = true;
  let drawScreenshot = true;
  let uidata = {
    windowdata: { maxheight: 0, maxwidth: 0 },
    clickdata: [],
    uielements: [],
  };
  let windowdata = uidata.windowdata;
  let clickdata = uidata.clickdata;
  //-------------------------------------------------------
  //-------------------------------------------------------
  //-------------------------------------------------------
  // TODO:
  // 0. Clicks von Partition laden -- check
  // 1. Screenshot an Server und vorlablen -- check
  // 2. Teilscreenshots von markierten Elementen an Server und vorlablen (OCR)
  // 3. Mapping für partition speichern
  // 4. Mapping für partition laden
  // 5. Mapping für partition anwenden
  // 6. Button resize
  //-------------------------------------------------------
  //-------------------------------------------------------
  //-------------------------------------------------------

  $: {
    if (partitionlabel > 0) getUIClicks(partitionlabel);
    getScreenshot(partitionlabel);
  }

  async function getScreenshot() {
    fetchWithSession(
      `/api/analysis/loadScreenshot/${analysisid}/${partitionlabel}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.screenshot == null) return;
        screenshot = new Image();
        screenshot.onload = function () {
          canvas.width = screenshot.width;
          canvas.height = screenshot.height;
        };
        screenshot.src = data.screenshot
        screenshot = screenshot;
      });
  }

  async function getUIClicks(partitionlabel) {
    const res = await fetchWithSession(
      `/api/analysis/windowPartitionDetails/` +
        analysisid +
        `/` +
        partitionlabel
    );
    const text = await res.json();
    uidata = text;
    allrects = uidata.uielements;
    windowdata = uidata.windowdata;
    clickdata = uidata.clickdata;
    currentid =
      Math.max(0, ...uidata.uielements.map((element) => element.id)) + 1;
    if (res.ok) {
      return text;
    } else {
      throw new Error(text);
    }
  }

  $: {
    if (canvas) {
      drawUIElements;
      drawScreenshot;
      drawClicks;
      drawButtons(
        allrects,
        windowdata,
        clickdata,
        screenshot,
        isdrawing,
        positionx,
        positiony,
        width,
        height
      );
    }
  }

  function drawButtons(
    allrects,
    windowdata,
    clickdata,
    screenshot,
    isdrawing,
    positionx,
    positiony,
    width,
    height
  ) {
    console.log(screenshot);
    if (screenshot && screenshot.complete && drawScreenshot) {
      canvas.height = Math.max(screenshot.height, windowdata.windowheight);
      canvas.width = Math.max(screenshot.width, windowdata.windowwidth);
      ctx = canvas.getContext("2d");

      ctx.drawImage(screenshot, 0, 0);
    } else {
      canvas.height = windowdata.windowheight;
      canvas.width = windowdata.windowwidth;
      ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    ctx.strokeRect(0, 0, windowdata.windowwidth, windowdata.windowheight);

//    if (drawClicks) {
//      ctx.strokeStyle = "#FF0000";
//      clickdata.forEach((click) => {
//        ctx.strokeRect(
//          click.relativeclickx - 2,
//          click.relativeclicky - 2,
//          5,
//          5
//        );
//      });
//    }
    ctx.strokeStyle = "#000000";

    if (drawUIElements) {
      allrects.forEach((rect) => {
        if (selectedRowIds.includes(rect.id)) {
          ctx.strokeStyle = "#FF0000";
        } else {
          ctx.strokeStyle = "#0000FF";
        }
        ctx.strokeRect(rect.positionx, rect.positiony, rect.width, rect.height);
      });
    }

    if (isdrawing) ctx.strokeRect(positionx, positiony, width, height);
  }

  let files = [];
  let screenshot;
  function handleImage(e) {
    var reader = new FileReader();
    reader.onload = function (event) {
      screenshot = new Image();
      screenshot.onload = function () {
        canvas.width = screenshot.width;
        canvas.height = screenshot.height;
      };
      screenshot.src = event.target.result;
      screenshot = screenshot;

      loadUIElementsFromScreenshot(screenshot.src);
    };
    reader.readAsDataURL(files[0]);
  }

  async function loadUIElementsFromScreenshot(dataurl) {
    const res = await fetchWithSession(`/api/analysis/uploadScreenshot`, {
      method: "POST",
      body: JSON.stringify({
        analysisid: analysisid,
        partitionlabel: partitionlabel,
        screenshot: dataurl,
      }),
    });
    let screenshotrects = await res.json();
    screenshotrects.forEach((rect) => {
      rect.id = currentid;
      currentid++;
      allrects.push(rect);
    });
    allrects = allrects;
    if (res.ok) {
      return 0;
    } else {
      throw new Error(text);
    }
  }

  let positionx = 0;
  let positiony = 0;
  let width = 0;
  let height = 0;
  function hightlightbutton(id) {
    allrects.find((element) => element.id == id).ishighlighted = true;
    allrects = allrects;
  }
  function resethighlight() {
    allrects.forEach((rect) => {
      rect.ishighlighted = false;
    });
    allrects = allrects;
  }

  let isdrawing = false;
  let ismoving = false;
  let dragpositionx = 0;
  let dragpositiony = 0;
  let origdragx = 0;
  let origdragy = 0;
  let movingrect;
  function startRect(e) {
    allrects.forEach((rect) => {
      if (
        e.offsetX >= rect.positionx &&
        e.offsetX <= rect.positionx + rect.width &&
        e.offsetY >= rect.positiony &&
        e.offsetY <= rect.positiony + rect.height
      ) {
        ismoving = true;
        movingrect = rect;
        dragpositionx = e.offsetX;
        dragpositiony = e.offsetY;
        origdragx = rect.positionx;
        origdragy = rect.positiony;
      }
    });
    if (!ismoving) {
      positionx = e.offsetX;
      positiony = e.offsetY;
      width = e.offsetX - positionx;
      height = e.offsetY - positiony;
      isdrawing = true;
    }
  }

  function drawRect(e) {
    if (isdrawing) {
      width = e.offsetX - positionx;
      height = e.offsetY - positiony;
    } else if (ismoving) {
      movingrect.positionx = e.offsetX + origdragx - dragpositionx;
      movingrect.positiony = e.offsetY + origdragy - dragpositiony;
      allrects = allrects;
    }
  }

  function clickRect(e) {
    allrects.forEach((rect) => {
      if (
        e.offsetX >= rect.positionx &&
        e.offsetX <= rect.positionx + rect.width &&
        e.offsetY >= rect.positiony &&
        e.offsetY <= rect.positiony + rect.height
      ) {
        if (selectedRowIds.includes(rect.id)) {
          selectedRowIds = selectedRowIds.filter((id) => id != rect.id);
        } else {
          selectedRowIds.push(rect.id);
        }
      }
    });
    allrects = allrects;
  }

  function endRect(e) {
    if (!ismoving) {
      positionx = width > 0 ? positionx : positionx + width;
      width = width > 0 ? width : -width;
      positiony = height > 0 ? positiony : positiony + height;
      height = height > 0 ? height : -height;
      if (width > 5 && height > 5) {
        allrects.push({ id: currentid, positionx, positiony, width, height });
        allrects = allrects;
        currentid++;
      }
    }

    isdrawing = false;
    ismoving = false;
  }
  let selectedRowIds = [];

  function sortRects(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  }

  function sortIDs(a, b) {
    if (parseInt(a) < parseInt(b)) return -1;
    if (parseInt(a) > parseInt(b)) return 1;
    return 0;
  }

  function deleteRect() {
    selectedRowIds.forEach((rowId) => {
      allrects = allrects.filter((element) => element.id != rowId);
    });
    allrects = allrects.sort(sortRects);
    selectedRowIds
      .sort(sortIDs)
      .reverse()
      .forEach((rowId) => {
        allrects.forEach((rect) => {
          if (rect.id > rowId) {
            rect.id = rect.id - 1;
          }
        });
      });
    allrects = allrects;
    currentid = Math.max(-1, ...allrects.map((element) => element.id)) + 1;
    selectedRowIds = [];
  }

  function removeButton() {
    allrects.splice(-1);
    allrects = allrects;
    currentid--;
  }

  function handleKeydown(e) {
    if (e.key == "Delete") {
      var originalElement = e.srcElement || e.originalTarget;
      if (
        (originalElement.tagName === "INPUT" &&
          originalElement.type != "checkbox") ||
        originalElement.tagName === "TEXTAREA"
      ) {
        return;
      }

      deleteRect();
    }
  }

  function saveButtons() {
    fetchWithSession(`/api/saveButtonMapping/${analysisid}/${partitionlabel}`, {
      method: "POST",
      body: JSON.stringify({
        buttons: allrects,
      }),
    });
  }

  $:{
    console.log(allrects);
  }

</script>

<svelte:window on:keydown={handleKeydown} />
<Grid fullWidth condensed>
  <Row>
    <Column>
      <Grid condensed>
        <Row>
          <Column>
            <Checkbox
              id="drawClicks"
              bind:checked={drawClicks}
              labelText="Draw Clicks"
              stlye="display:inline-block"
            />
          </Column>
          <Column>
            <Checkbox
              id="drawUIElements"
              bind:checked={drawUIElements}
              labelText="Draw UI Elements"
              stlye="display:inline-block"
            />
          </Column>
          <Column>
            <Checkbox
              id="drawScreenshot"
              bind:checked={drawScreenshot}
              labelText="Draw Screenshot"
              stlye="display:inline-block"
            />
          </Column>
        </Row>
      </Grid>
      {Math.max(0, ...allrects.map((element) => element.id))}
      {currentid}
      <div
        style="display:block; width:50vw; height:50vh; min-height:400px; overflow-x:scroll; overflow-y:scroll"
      >
        <canvas
          bind:this={canvas}
          on:click={clickRect}
          on:mousedown={startRect}
          on:mouseup={endRect}
          on:mousemove={drawRect}
          style="cursor:crosshair; border:1px solid grey;"
        ></canvas>
      </div>
    </Column>
    <Column>
      <div class="button_wrapper">
        <ButtonFileUploader
          text="Add Screenshot"
          secondary={true}
          on:change={handleImage}
          bind:files
        />
        <ButtonNew
          text="Undo"
          iconLeft={true}
          icon="undo"
          setting={true}
          secondary={true}
          on:click={removeButton}
        />
        <ButtonNew
          text="Save"
          iconLeft={true}
          icon="save"
          setting={true}
          secondary={true}
          on:click={saveButtons}
        />
        <ButtonNew
          text="Delete"
          iconLeft={true}
          icon="trash"
          setting={true}
          danger={true}
          on:click={deleteRect}
        />
      </div>
      <div style="display:block; height:50vh;  overflow-y:scroll">
        <DataTable
          on:mouseenter:row={(row) => hightlightbutton(row.detail.id)}
          on:mouseleave:row={() => resethighlight()}
          batchSelection={true}
          size="compact"
          headers={[
            { key: "name", value: "name" },
            { key: "positionx", value: "X" },
            { key: "positiony", value: "Y" },
            { key: "width", value: "Width" },
            { key: "height", value: "Height" },
          ]}
          rows={allrects}
          sortable
          bind:selectedRowIds
        >
<!--
          <span
            slot="cell"
            let:row
            let:cell
            style="width:100%; display:inline-block; cursor:pointer"
          >
            <TextInput size="sm" bind:value={allrects[row.id][cell.key]} />
          </span>
-->
        </DataTable>
      </div>
    </Column>
  </Row>
</Grid>

<style>
  .button_wrapper {
    display: flex;
    gap: 0.2rem;
  }
</style>
